import { UserLayout, TabLayout, RouteView, BlankLayout, PageView,HomeLayout } from '@/components/layouts'
import workRouter from  '@/config/router.work.config'
/**
 * 走菜单，走权限控制
 * @type {[null,null]}
 */
export const asyncRouterMap = [

  {
    path: '/home',
    name: '/home',
    component: TabLayout,
    meta: { title: '首页' },
    redirect: '/dashboard/analysis',
    children: [

    ]
  },
  {
    path: '*', redirect: '/404', hidden: true
  }
]

/**
 * 基础路由
 * @type { *[] }
 */
export const constantRouterMap = [
  ...workRouter,
  {
    path: '/user/guide',
    component: () => import(/* webpackChunkName: "user" */ '@/views/apppad/Guide')
  },
  {
    path: '/user',
    component: UserLayout,
    redirect: '/user/login',
    hidden: true,
    children: [
      {
        path: 'login',
        name: 'login',
        component: () => import(/* webpackChunkName: "user" */ '@/views/user/Login')
      },
    ]
  },

  {
    path: '/test',
    component: BlankLayout,
    redirect: '/test/home',
    children: [

    ]
  },
    // 驾驶舱
  {
    path: '/Cockpit',
    name: 'Cockpit',
    component: () => import('@/views/dashboard/Cockpit'),
    meta: { title: '首页' },
    children: [

    ]
  },
  {
    path: '/404',
    component: () => import(/* webpackChunkName: "fail" */ '@/views/exception/404')
  },

]
